import { AnimatePresence } from 'framer-motion';
import { FC, useState } from 'react';
import styled from 'styled-components';

import { ReactComponent as FileTextIcon } from '@/assets/icons/file-text.svg';
import FilterButton from '@/components/FilterDropdown/FilterButton';
import useNetwork from '@/hooks/dq/useNetwork';
import { EditorialQueuePage } from '@/types/resources';
import { EditorialFacebookPostNetwork } from '@/utils/enums';

import PageGuideModal from './PageGuideModal';

const StyledFilterButton = styled(FilterButton)`
  margin: 0 !important;
  border-color: ${({ theme }) => theme.colors.grayscale};
  padding-left: 16px;
  padding-right: 16px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  activePage: EditorialQueuePage;
}

const PageGuideButton: FC<Props> = ({ activePage }) => {
  const [showModal, setShowModal] = useState(false);
  const [network] = useNetwork();

  if (network !== EditorialFacebookPostNetwork.FACEBOOK) {
    return null;
  }

  return (
    <>
      <StyledFilterButton
        text="Page guide"
        filterApplied={false}
        isActive={false}
        onClick={() => setShowModal(true)}
        icon={<FileTextIcon />}
      />
      <AnimatePresence>
        {showModal && (
          <PageGuideModal
            onClose={() => setShowModal(false)}
            activePage={activePage}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default PageGuideButton;
